import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
  OnInit,
} from '@angular/core';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { SessionService } from '../../../../core/_services/session.service';
import { User } from '../../../../core/_models/user.model';
import { Office } from '../../../../core/_models/office.model';

@Component({
  selector: 'kt-profile-image',
  templateUrl: './profile-image.component.html',
  styleUrls: ['./profile-image.component.scss'],
  standalone: false,
})
export class ProfileImageComponent implements OnInit {
  @ViewChild('imgInput') profileImgInput: ElementRef;
  @Input() logoPath: string;
  @Input() user: User;
  @Input() size = 'large';
  @Input() border = false;
  @Input() activeOffice: Office;
  @Input() type = 'user-pic';
  @Input() companyName: string;
  @Input() allowUpload = true;
  @Input() disableUpload = true;
  @Input() loading: boolean;
  @Output() change: EventEmitter<File> = new EventEmitter<File>();
  onHover = false;
  totalOffice: number;

  defaultLogoPath = '/assets/media/icons/company-account.svg';
  showerrormessage = false;
  normalizedLogoPath: string;
  isDefaultLogo: boolean;

  constructor(
    private readonly ref: ChangeDetectorRef,
    private readonly sessionService: SessionService,
    private router: Router,
  ) {}
  currentUser = this.sessionService.getCurrentUser();

  ngOnInit(): void {
    this.totalOffice = this.currentUser?.officeAccesses?.length || 0;
  }

  handleLogoError(): void {
    this.logoPath = undefined;
    this.ref.detectChanges();
  }

  get isOfficeSettings(): boolean {
    return this.router.url.includes('/settings/office-settings');
  }
  getInitial(): string {
    if (this.user) {
      return `${this.user?.firstName?.[0]?.toUpperCase() || ''}${
        this.user?.lastName?.[0]?.toUpperCase() || ''
      }`;
    }
    return '';
  }

  onLogoChange(event): void {
    const imgFile = event.target.files[0],
      validImgSize = 500 * 1024 * 1024;
    if (imgFile.size > validImgSize) {
      this.logoPath = this.defaultLogoPath;
      this.showerrormessage = true;
      this.ref.detectChanges();
      return;
    }

    const reader = new FileReader();
    reader.onload = (e: any) => {
      const img = new Image();
      img.src = e.target.result;
      img.onload = () => {
        if (img.width > 320 || img.height > 320) {
          this.logoPath = this.defaultLogoPath;
          this.showerrormessage = true;
        } else {
          this.logoPath = e.target.result;
          this.showerrormessage = false;
          this.change.emit(imgFile);
        }
        this.ref.detectChanges();
      };
    };
    reader.readAsDataURL(imgFile);
  }

  onImageLoaded(imageDataUrl: string, imgFile: File): void {
    this.logoPath = imageDataUrl;
    this.change.emit(imgFile);
    this.ref.detectChanges();
  }

  onProfilePicHover(value: boolean): void {
    this.onHover = value;
  }

  isOfficeAdmin(user: User): boolean {
    return user.officeAccesses?.some((officeAccess) =>
      officeAccess?.roles.some((role) => role.name === 'OFFICE_ADMIN'),
    );
  }

  onclick() {
    Swal.mixin({
      customClass: {
        actions: 'swal-actions-profile',
        cancelButton: 'swal-cancel-button-profile',
        confirmButton: 'swal-confirm-button-profile',
        container: 'swal-container-profile',
        title: 'swal2-title-profile',
        icon: 'swal2-icon',
        popup: 'swal2-popup-profile',
        htmlContainer: 'swal2-html-container-profile',
      },
    })
      .fire({
        html: `
        <div style="text-align: left; overflow: hidden;">
          <img src="/assets/media/icons/wallet/error.svg" alt="Image" style="width: 55px; height: 55px; margin-bottom: 10px;">
          <h2 style="margin: 0;">Are you sure?</h2>
          <p style="margin-top: 10px;">Do you really want to remove this photo? This action can't be undone.</p>
        </div>
      `,
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d02b20',
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Cancel',
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          this.removeProfilePic();
        }
      });
  }

  removeProfilePic(): void {
    this.logoPath = this.defaultLogoPath;
    this.profileImgInput.nativeElement.value = null;
    this.change.emit(undefined);
    this.ref.detectChanges();
  }

  get actionTitle(): string {
    this.normalizedLogoPath = this.logoPath?.replace(/^https?:\/\/[^/]+/, '');
    this.isDefaultLogo = this.normalizedLogoPath === this.defaultLogoPath;

    return this.isDefaultLogo
      ? $localize`:@@profile.upload-photo:Upload photo`
      : $localize`:@@profile.replace-photo:Replace photo`;
  }

  get isRemoveButtonDisabled(): boolean {
    return this.isDefaultLogo;
  }
}
